// extracted by mini-css-extract-plugin
export default {"historySelector":"PatientHistorySelector_historySelector__lHUqe"};